export const TEXT_KEYS = {
    TITLE: 'end-of-operation__title',
    MESSAGE: 'end-of-operation__message'
};

export const OPERATION_ENDING_STATUS = 'OPERATION_ENDING_STATUS';
